export default "__VITE_PUBLIC_ASSET__8703af6f__"